export default function(){
    const { Handlebars, bugsnagClient } = window;

    const state = {
        managedContainers: {},
    }

    /**
     * addManagedContainer -- add the skeleton manager to a container on the page
     * @param {Object} container
     * @param {string} container.containerId - ID of the container on the page where the skeleton and items will go.
     * @param {string} container.skeletonId -ID of the handlebars template used for this skeleton.
     * @param {number} container.initialCount - How many skeletons to show on initial load. A good value would be the pageSize.
     */
    const addManagedContainer = (container) => {
        // Don't overwrite a managed container by mistake
        if(state.managedContainers[container.containerId] === undefined) {
            state.managedContainers[container.containerId] = container;
            bindListenersToContainer(container);
            return true;
        } else {
            bugsnagClient.notify(
                new Error(`Notice: there was already a container with id ${container.containerId}. Skeleton manager not binding again to avoid overwriting an existing container.`),
                {metaData: {"Managed Containers": state.managedContainers}}
                );
            return false;
        }
    }


    /**
     * bindListenersToContainer -- bind the event listeners to the container
     * @param {Object} container
     * @param {string} container.containerId - ID of the container on the page where the skeleton and items will go.
     * @param {string} container.skeletonId -ID of the handlebars template used for this skeleton.
     * @param {number} container.initialCount - How many skeletons to show on initial load. A good value would be the pageSize.
     */
    const bindListenersToContainer = (container) => {
        let {containerId} = container;
        const $containerId = $(`#${containerId}`);

        $containerId.on('startSkeleton', () => {
            startSkeleton(containerId);
        });

        $containerId.on('replaceSkeletonWithContent', (event, content) => {
            replaceSkeletonWithContent(containerId, content);
        });

        $containerId.on('removeAllSkeletonsFromContainer', () => {
            removeAllSkeletonsFromContainer(containerId);
        });

    }

    /**
     * startSkeleton -- add initialCount skeletons to the container with
     * @param {string} containerId - ID of the container on the page where the skeleton and items will go.
     */
    const startSkeleton = (containerId) => {
        let container = state.managedContainers[containerId];
        if(container === undefined) {
            bugsnagClient.notify(new Error(`Couldn't start skeleton on container with id ${containerId}`));
            return false;
        } else {
            // Start skeletoning
            let $containerId = $(`#${container.containerId}`);
            let skeletonItem = Handlebars.compile($(`#${container.skeletonId}`).html());
            for (let i = 0; i < container.initialCount; i++) {
                $containerId.append(skeletonItem);
            }
        }
    }

    /**
     * replaceSkeletonWithContent -- replace skeleton objects with content
     * @param {string} containerId - ID of the container on the page
     * @param {Object[]} content - DOM objects
     */
    const replaceSkeletonWithContent = (containerId, content) => {
        let container = state.managedContainers[containerId];
        const $containerId = $(`#${containerId}`);
        if(container === undefined) {
            bugsnagClient.notify(new Error(`Couldn't detach skeleton from container with id ${containerId}`));
        } else {
            // Start replacing with content
            removeAllSkeletonsFromContainer(containerId);
            $containerId.append(content);
        }
    }

    /**
     * removeAllSkeletonsFromContainer -- removes all skeletons from container 🙃
     * @param {string} containerId - ID of the container on the page
     * @param {boolean} instant - Remove instantly or with delay, default instant.
     */
    const removeAllSkeletonsFromContainer = (containerId, instant = true) => {
        if(instant) {
            $(`#${containerId} > .skeleton-content`).remove();
        } else {
            $(`#${containerId} > .skeleton-content`).fadeOut();
        }
    }

    const removeContainer = (containerId) => {
        if (isThisContainerManaged(containerId)) {
            delete(state.managedContainers[containerId]);
        }
    };

    /**
     * getManagedContainers -- gets all the managed containers
     */
    const getManagedContainers = () => {
        return state.managedContainers ?? false;
    }

    /**
     * isThisContainerManaged -- checks if the given container ID is managed by skeleton manager
     * @param {string} containerId - ID of the container on the page
     * @returns {boolean} True if container is managed, false if it is not managed.
     */
    const isThisContainerManaged = (containerId) => {
        return containerId in state.managedContainers;
    }


    return {
        addManagedContainer,
        getManagedContainers,
        isThisContainerManaged,
        removeContainer,
    };
}
